import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Row, Col, Hide } from '@gympass/yoga'
import { Img2d10 } from '@gympass/yoga-illustrations'

import useReCaptcha from '@hooks/useReCaptcha'

import Appbar from '@components/Appbar'
import Footer from '@components/Footer'
import Container from '@components/Container'

import * as Style from './AlreadyEligible.style'

function AlreadyEligible() {
  const { resetRecaptcha } = useReCaptcha()
  resetRecaptcha()

  return (
    <section>
      <Appbar />

      <Container>
        <Style.Main>
          <Row>
            <Col md={7} xxs={12} xl-start={1} xl={8}>
              <Style.Title>
                <FormattedMessage id="smb_acquisition_thankyou.already_eligible.title" />
              </Style.Title>

              <Style.Subtitle>
                <FormattedMessage
                  id="smb_acquisition_thankyou.already_eligible.subtitle"
                  values={{
                    a: (...chunks) => (
                      <a
                        href="https://www.gympass.com/end-user/br/sign-up?registration_type=b2b"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {chunks}
                      </a>
                    ),
                  }}
                />
              </Style.Subtitle>
            </Col>

            <Hide>
              <Col xl={4}>
                <Img2d10
                  width={230}
                  height={230}
                  role="figure"
                  aria-label="i2s-settings-modal"
                />
              </Col>
            </Hide>
          </Row>
        </Style.Main>
      </Container>

      <Footer />
    </section>
  )
}

export default AlreadyEligible
